var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisaWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.832,
    height: 18.677,
    viewBox: "0 0 57.832 18.677",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "visa",
    d: "M21.957,8.457,14.386,26.519H9.446L5.721,12.1A1.976,1.976,0,0,0,4.61,10.517,19.634,19.634,0,0,0,0,8.979l.111-.523H8.063A2.178,2.178,0,0,1,10.217,10.3l1.969,10.453L17.048,8.457ZM41.314,20.623c.019-4.769-6.593-5.031-6.547-7.162.014-.648.631-1.337,1.981-1.513a8.819,8.819,0,0,1,4.61.81l.819-3.831a12.547,12.547,0,0,0-4.371-.8c-4.619,0-7.87,2.458-7.9,5.974-.029,2.6,2.321,4.048,4.092,4.916,1.822.884,2.434,1.453,2.424,2.243-.012,1.214-1.451,1.747-2.8,1.769a9.8,9.8,0,0,1-4.8-1.14l-.846,3.957a14.1,14.1,0,0,0,5.2.959c4.908,0,8.121-2.424,8.137-6.178m12.2,5.9h4.323L54.061,8.457H50.07a2.128,2.128,0,0,0-1.99,1.325L41.07,26.519h4.906l.976-2.7h6Zm-5.212-6.4,2.458-6.783,1.417,6.783ZM28.634,8.457,24.771,26.519H20.1L23.964,8.457Z",
    transform: "translate(0 -8.124)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaWhite);
export default __webpack_public_path__ + "static/media/visa-white.5176d2a4156474befa83f8b32ea1239f.svg";
export { ForwardRef as ReactComponent };